var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"disabled":!_vm.isOverflowing,"max-width":"1000","bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({ref:"sidebarValue",staticClass:"sidebar-value"},on),[_c('span',[_vm._v(_vm._s(_vm.value))])])]}}])},[_c('span',[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }